import Content from './Content';

const RegistrationFail = () => {
  return <Content messages={'Kích hoạt tài khoản thất bại'} />;
};

export default RegistrationFail;
